/* eslint-disable no-param-reassign */
import React, { InputHTMLAttributes, useEffect, useState } from 'react';

import { useField } from 'formik';

import { Container } from './styles';

interface CheckBoxProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  name: string;
  optional?: boolean;
}

const BooleanField: React.FC<CheckBoxProps> = ({
  id,
  name,
  label,
  optional = false,
  ...rest
}) => {
  const [, , helpers] = useField<boolean | undefined>(name);
  const { setValue } = helpers;

  const [checkboxValue, setCheckboxValue] = useState<boolean>(false);

  useEffect(() => {
    setValue(checkboxValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkboxValue]);

  return (
    <Container>
      <label htmlFor={id} key={id}>
        <input
          key={id}
          onChange={() => setCheckboxValue(!checkboxValue)}
          type="checkbox"
          id={id}
          {...rest}
        />
        {label}
        {optional && <small>(opcional)</small>}
      </label>
    </Container>
  );
};

export default BooleanField;
